export default __webpack_public_path__ + "static/media/6.9bea3e5f.jpg";